import * as R from 'ramda'
import { lti as actions } from '../actions'

export const initialState = {
  page: '',
  user: {},
  board: {},
  payload: {},
  loadingParams: true
}

export const setLti = lti => dispatch => {
  dispatch({
    type: actions.SET_LTI,
    lti
  })
}
